import { Link } from "react-router-dom";
import { hotRanking, comics } from "@/mocks/comics";

export default function Ranking() {
  const rankComics = hotRanking.map((r) => ({
    ...r,
    comic: comics.find((c) => c.id === r.id),
  }));

  const rankColors = ["bg-accent-500 text-background-50", "bg-primary-400 text-background-50", "bg-secondary-400 text-background-50"];

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div>
          <p className="text-sm font-bold text-primary-600">追更热度榜</p>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            本周最热连载
          </h2>
          <p className="mt-2 max-w-md text-sm text-foreground-600">
            实时统计读者追更热度，上榜作品均为更新稳定、口碑与热度双高的长期连载神作。
          </p>

          <ol className="mt-7 space-y-2.5">
            {rankComics.map((item, idx) => (
              <li key={item.id}>
                <Link
                  to={`/series/${item.id}`}
                  className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-100 px-4 py-3 transition-all hover:border-primary-200 hover:bg-background-50"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                      rankColors[idx] ?? "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-600">
                      {item.title}
                    </p>
                    <p className="text-xs text-foreground-500">
                      热度 {item.heat} · 评分 {item.score}
                    </p>
                  </div>
                  <span className="whitespace-nowrap text-xs font-medium text-primary-600">
                    追更 <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>

        <div className="flex flex-col rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-8">
          <p className="text-sm font-bold text-primary-600">本周更新</p>
          <h3 className="mt-2 font-heading text-2xl text-foreground-950">刚更新 · 趁热追</h3>
          <p className="mt-2 text-sm text-foreground-600">
            以下长篇连载今日刚刚更新最新话，点击即可继续你的追更旅程。
          </p>

          <div className="mt-6 flex flex-1 flex-col justify-center gap-4">
            {rankComics.slice(0, 4).map((item, i) => (
              <Link
                key={item.id}
                to={`/series/${item.id}`}
                className="group flex items-center gap-4"
              >
                <img
                  src={item.comic?.image}
                  alt={`${item.title} 最新话封面`}
                  className="h-16 w-12 shrink-0 rounded-md object-cover"
                />
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-600">
                    {item.title}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">
                    更新至第 {item.comic?.chapters} 话 · {item.comic?.updated}
                  </p>
                  <span className="mt-1.5 inline-block rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700">
                    {i === 0 ? "全新话上线" : "稳定更新中"}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}